const navContainer = document.querySelector(".js-main-navbar");
const initNav = () => {
  setScrollbarWidth();

  const navigationPopover = document.getElementById("navigation-popover");
  const navigationPopoverTrigger = document.getElementById("navigation-popover-trigger");

  if (!navigationPopover || !navigationPopoverTrigger) {
    return;
  }

  let navigationPopoverActive = navigationPopoverTrigger.offsetParent !== null;
  if (navigationPopoverActive) {
    navigationPopover.setAttribute("popover", "");
  }

  const navItems = navContainer.querySelectorAll("a[popovertarget]");
  navItems.forEach((item) => {
    let closeTimeout;

    const popoverTargetId = item.getAttribute("popovertarget");
    const popoverTarget = document.querySelector(`#${popoverTargetId}`);

    if (popoverTarget) {
      item.hidePopover = () => {
        popoverTarget.hidePopover();
      };

      item.addEventListener("click", (e) => {
        if (navigationPopoverActive) {
          e.preventDefault();

          popoverTarget.style.setProperty("--anchor-top", `64px`);
          setTimeout(popoverTarget.togglePopover(), 1);
        }
      });

      item.addEventListener("mouseover", (e) => {
        if (!navigationPopoverActive) {
          clearTimeout(closeTimeout);

          setOffset(item, popoverTarget);
          popoverTarget.showPopover();
        }
      });

      item.addEventListener("mouseleave", (e) => {
        if (!navigationPopoverActive) {
          closeTimeout = setTimeout(item.hidePopover, 1);
        }
      });

      popoverTarget.querySelector(".c-navigation-menu__sub").addEventListener("mouseover", (e) => {
        if (!navigationPopoverActive) {
          clearTimeout(closeTimeout);
        }
      });

      popoverTarget.querySelector(".c-navigation-menu__sub").addEventListener("mouseleave", (e) => {
        if (!navigationPopoverActive) {
          closeTimeout = setTimeout(item.hidePopover, 1);
        }
      });

      window.addEventListener("resize", () => {
        setScrollbarWidth();

        navigationPopoverActive = navigationPopoverTrigger.offsetParent !== null;
        if (navigationPopoverActive) {
          navigationPopover.setAttribute("popover", "");
        } else {
          navigationPopover.removeAttribute("popover");
        }
      });
    }
  });
};

const setScrollbarWidth = () => {
  const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
  document.documentElement.style.setProperty("--scrollbar-width", `${scrollbarWidth}px`);
};

const setOffset = (item, popoverTarget) => {
  const itemPosition = item.getBoundingClientRect();
  const arrowPosition = itemPosition.left + itemPosition.width / 2;
  const { y: navbarBottom } = navContainer.getBoundingClientRect();
  const topSpacing = navbarBottom + navContainer.offsetHeight;

  popoverTarget.style.setProperty("--arrow-position-left", `${arrowPosition}px`);

  popoverTarget.style.setProperty("--popover-hover-trigger", popoverTarget.id);

  popoverTarget.style.setProperty("--anchor-top", `${topSpacing}px`);
};

export { initNav };
